// Section with Editor
$(document).on('shopify:section:load', function(e){ 
  $('#' + e.target.id).find('[data-section]').sectionJs();
}).ready(function() {
  $('[data-section]').each(function(){ $(this).sectionJs() });
});

$.fn.sectionJs = function(){
  var $this = this;
  if($this.data('section') == "FullWidthSlider") {
    $this.find('.main-slider-active').FullWidthSlider();
  }else if($this.data('section') == "FeaturedCollection") {
    $this.find('.latest_product_slider').FeaturedCollection();
  }else if($this.data('section') == "TabProduct") {
   $this.find('.tab_product_slider').TabProduct();
  }else if($this.data('section') == "FeaturedProduct") {
    $this.find('.promotion-slider-active').FeaturedProduct();
  }else if($this.data('section') == "ProductWidget") {
    $this.find('.small-list-wrapper').ProductWidget();
  }else if($this.data('section') == "LatestBlog") {
    $this.find('.latest-blog-slider-active').LatestBlog();
  }else if($this.data('section') == "CategoryBanner") {
    $this.find('.ctg-slider-active').CategoryBanner();
  }else if($this.data('section') == "FeaturedCollectionBanner") {
    $this.find('.latest_product_slider_banner').FeaturedCollectionBanner();
  }else if($this.data('section') == "ListCollection") {
    $this.find('.list_product_slider').ListCollection();
  }else if($this.data('section') == "Testimonial") {
   $this.find('.testimonial-slider').Testimonial();
  }else if($this.data('section') == "Brand") {
   $this.find('.total-brand').Brand();
  }else if($this.data('section') == "CustomCollection") {
   $this.find('.custom_product_slider').CustomCollection();
  }else if($this.data('section') == "RelatedProduct") {
   $this.find('.related_product_slider').RelatedProduct();
  }else if($this.data('section') == "single_product") {
    $this.find('.slider-nav').single_product();
  }else if($this.data('section') == "HeaderSections") {
    $this.HeaderSectionsActivation();
  }else if($this.data('section') == "CollectionPage") {
    $this.CollectionPageActivation();
  }else if($this.data('section') == "BannerWithCollection") {
    $this.find('.product_column2').BannerWithCollection();
  }else if($this.data('section') == "CollectionThumbnail") {
    $this.find('.product_column1').CollectionThumbnail();
  }else if($this.data('section') == "SectionWithSidebar") {
    $this.SectionWithSidebar();
  }else if($this.data('section') == "SectionWithSidebar2") {
    $this.SectionWithSidebar2();
  }else{}   
}


//  slider active js
$.fn.FullWidthSlider = function() {
  var $FullWidthSliderVAR = this;
  $FullWidthSliderVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        fade: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  latest product active js
$.fn.FeaturedCollection = function() {
  var $FeaturedCollectionVAR = this;
  $FeaturedCollectionVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  tab product active js
$.fn.TabProduct = function() {
  var $TabProductVAR = this;
  $TabProductVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  featured product active js
$.fn.FeaturedProduct = function() {
  var $FeaturedProductVAR = this;
  $FeaturedProductVAR.slick({
        speed: 1000,dots: true,
        arrows: false,
        infinite: true
  });
};

//  product widget active js
$.fn.ProductWidget = function() {
  var $ProductWidgetVAR = this;
  $ProductWidgetVAR.slick({
        speed: 1000,dots: false,
        arrows: false,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  product widget active js
$.fn.LatestBlog = function() {
  var $LatestBlogVAR = this;
  $LatestBlogVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  category banner active js
$.fn.CategoryBanner = function() {
  var $CategoryBannerVAR = this;
  $CategoryBannerVAR.slick({
        speed: 1000,dots: false,
        arrows: false
  });
};

//  product widget active js
$.fn.FeaturedCollectionBanner = function() {
  var $FeaturedCollectionBannerVAR = this;
  $FeaturedCollectionBannerVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};


//  product widget active js
$.fn.ListCollection = function() {
  var $ListCollectionVAR = this;
  $ListCollectionVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  testimonial active js
$.fn.Testimonial = function() {
  var $TestimonialVAR = this;
  $TestimonialVAR.slick({
        speed: 1000,dots: true,
        arrows: false,
        infinite: true,
  });
};

//  brand active js
$.fn.Brand = function() {
  var $BrandVAR = this;
  $BrandVAR.slick({
        speed: 1000,dots: false,
        arrows: false,
        infinite: true,
  });
};

//  custom collection product active js
$.fn.CustomCollection = function() {
  var $CustomCollectionVAR = this;
  $CustomCollectionVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  related product active js
$.fn.RelatedProduct = function() {
  var $RelatedProductVAR = this;
  $RelatedProductVAR.slick({
        speed: 1000,dots: false,
        arrows: true,
        infinite: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};

//  related product active js
$.fn.single_product = function() {
  var $single_productVAR = this;
  $single_productVAR.slick({slidesToShow: 4,
        slidesToScroll: 1,
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
  });
};



(function($) {
  "use strict";

  jQuery(document).ready(function(){


    // All jQuery activation code paste here
    

    /*----------  Menu sticky ----------*/

    var windows = $(window);
    var screenSize = windows.width();
    var sticky = $('.header-sticky');
    var stickyAbsolute = $('.header-sticky--absolute');
    var $html = $('html');
    var $body = $('body');


    windows.on('scroll', function() {
        var scroll = windows.scrollTop();
        var headerHeight = sticky.height();
        var headerHeightAbsolute = stickyAbsolute.height();

        if (screenSize >= 992) {
            if (scroll < headerHeight) {
                sticky.removeClass('is-sticky');
            } else {
                sticky.addClass('is-sticky');
            }

            if (scroll < headerHeightAbsolute) {
                stickyAbsolute.removeClass('is-sticky--absolute');
            } else {
                stickyAbsolute.addClass('is-sticky--absolute');
            }
        }



        //code for scroll top

        if (scroll >= 400) {
            $('#scroll-top').fadeIn();
        } else {
            $('#scroll-top').fadeOut();
        }

    });




    /*----------  Scroll to top  ----------*/

    $('#scroll-top').on('click', function() {
        $('html,body').animate({
            scrollTop: 0
        }, 2000);
    });


    /*=====  End of menu sticky and scroll to top  ======*/


    /*=============================================
    =            minicart and settings active            =
    =============================================*/

    $('#furnimal_minicart-trigger').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('.mini-cart').toggleClass('active');
        $('#furnimal_settings-menu-wrapper').removeClass('active');
        $('body').addClass('active-overlay');
    });

    $('#furnimal_header-settings-trigger').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('.furnimal_settings-menu-wrapper').toggleClass('active');
        $('#mini-cart').removeClass('active');
        $('body').addClass('active-overlay');
    });

    $('#currency-trigger').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('#currency-menu').toggleClass('active');
        $('body').addClass('active-overlay');
    });

    $('#language-trigger').on('click', function(e) {
        e.preventDefault();
        $(this).siblings('#language-menu').toggleClass('active');
        $('body').addClass('active-overlay');
    });

    /*Minicart Close When Click Outside Minicart*/

    $('body').on('click', function(e) {
        var $target = e.target;
        if (!$($target).is('.furnimal_header-cart-icon, .furnimal_header-settings-icon, #currency-trigger, #language-trigger') && !$($target).parents().is('.furnimal_header-cart-icon, .furnimal_header-settings-icon, #currency-trigger') && $('body').hasClass('active-overlay')) {
            $('.mini-cart, .furnimal_settings-menu-wrapper, #currency-menu, #language-menu').removeClass('active');
            $('body').removeClass('active-overlay');
        }
    });

    /*=====  End of minicart and settings active  ======*/


    /*=============================================
    =            perfect scrollbar active            =
    =============================================*/

    $('.ps-scroll').each(function() {
        if ($('.ps-scroll').length) {
            const ps = new PerfectScrollbar($(this)[0]);
        }
    });

    /*=====  End of perfect scrollbar active  ======*/

    /*=============================================
    =            search overlay active            =
    =============================================*/

    $('#furnimal_furnimal_search-overlay-trigger').on('click', function() {
        $('#furnimal_search-overlay').show();
    });


    $('#close-furnimal_search-overlay').on('click', function() {
        $('#furnimal_search-overlay').hide();
    });

    /*=====  End of search overlay active  ======*/


    /*=============================================
    =            furnimal_offcanvas menu            =
    =============================================*/

    var $furnimal_offcanvasNav = $('.furnimal_offcanvas-navigation'),
        $furnimal_offcanvasNavSubMenu = $furnimal_offcanvasNav.find('.sub-menu');

    /*Add Toggle Button With Off Canvas Sub Menu*/
    $furnimal_offcanvasNavSubMenu.parent().prepend('<span class="menu-expand"><i></i></span>');

    /*Close Off Canvas Sub Menu*/
    $furnimal_offcanvasNavSubMenu.slideUp();

    /*Category Sub Menu Toggle*/
    $furnimal_offcanvasNav.on('click', 'li a, li .menu-expand', function(e) {
        var $this = $(this);
        if (($this.parent().attr('class').match(/\b(furnimal_menu-item-has-children|has-children|has-sub-menu)\b/)) && ($this.attr('href') === '#' || $this.hasClass('menu-expand'))) {
            e.preventDefault();
            if ($this.siblings('ul:visible').length) {
                $this.parent('li').removeClass('active');
                $this.siblings('ul').slideUp();
            } else {
                $this.parent('li').addClass('active');
                $this.closest('li').siblings('li').removeClass('active').find('li').removeClass('active');
                $this.closest('li').siblings('li').find('ul:visible').slideUp();
                $this.siblings('ul').slideDown();
            }
        }
    });

    /*=====  End of furnimal_offcanvas menu  ======*/


    /*=============================================
    =            mobile menu activation            =
    =============================================*/

    $('#mobile-menu-trigger').on('click', function() {
        $('#furnimal_offcanvas-mobile-menu').removeClass('inactive').addClass('active');
    });


    $('#furnimal_offcanvas-menu-close-trigger').on('click', function() {
        $('#furnimal_offcanvas-mobile-menu').removeClass('active').addClass('inactive');
    });

    /*=====  End of mobile menu activation  ======*/



    /*new*/

    /*----------------------------------
    10. Youtube Popup
    ------------------------------------*/

    $('.play__btn').yu2fvl();


    /*=============================================
    =            masonry activation            =
    =============================================*/

    windows.on("load", function() {
        $('.masonry-category-layout').masonry();
        $('.masonry-category-layout--style2').masonry();
    });


    /*=====  End of masonry activation  ======*/



    /*=============================================
    =            newsletter popup area            =
    =============================================*/

    $("#close-newsletter-popup").on("click", function() {
        $("#newsletter-popup-area").addClass("d-none");
    });

    /*=====  End of newsletter popup area  ======*/


    /*=============================================
    =            product view mode            =
    =============================================*/

    $('.list-grid-icon button').on('click', function(e) {
        e.preventDefault();

        var shopProductWrap = $('.shop-furnimal_product-wrap');
        var viewMode = $(this).data('target');

        $('.list-grid-icon button').removeClass('active');
        $(this).addClass('active');
        shopProductWrap.removeClass('grid three-grid-column four-grid-column five-column list').addClass(viewMode);

        if (viewMode == 'grid three-grid-column') {
            shopProductWrap.children().addClass('col-lg-4').removeClass('col-lg-3 col-lg-is-5');
        }

        if (viewMode == 'grid four-grid-column') {
            shopProductWrap.children().addClass('col-lg-3').removeClass('col-lg-4 col-lg-is-5');
        }

        if (viewMode == 'grid five-column') {
            shopProductWrap.children().addClass('col-lg-is-5').removeClass('col-lg-4 col-lg-3');
        }
    });
    /*=====  End of product view mode  ======*/



    /*---- Countdown Activation ----*/
    $('[data-countdown]').each(function() {
        var $this = $(this),
            finalDate = $(this).data('countdown');
        $this.countdown(finalDate, function(event) {
            $this.html(event.strftime('<div class="single-count sc_day"><span class="sc_time">%D</span><span class="sc_text">Days,</span></div><div class="single-count sc_hour"><span class="sc_time">%H</span><span class="sc_text">:</span></div><div class="single-count sc_min"><span class="sc_time">%M</span><span class="sc_text">:</span></div><div class="single-count sc_sec"><span class="sc_time">%S</span><span class="sc_text"></span></div>'));
        });
    });




    /*=============================================
    =            zoom and light gallery active            =
    =============================================*/

    $('.single_product_top .single-image').zoom();

    /*=====  End of zoom active  ======*/

    /*=============================================
    =            sticky sidebar active          =
    =============================================*/

    $('.single-furnimal_product-details-sticky').stickySidebar({
        topSpacing: 90,
        bottomSpacing: -80,
        minWidth: 768
    });

    /*=====  End of sticky sidebar active  ======*/


    /*=============================================
    =            payment  method select            =
    =============================================*/


    $('[name="payment-method"]').on('click', function() {

        var $value = $(this).attr('value');

        $('.single-method p').slideUp();
        $('[data-method="' + $value + '"]').slideDown();

    });


    /*=====  End of payment  method select  ======*/


    /*=============================================
    =            shipping form toggle            =
    =============================================*/

    $('[data-shipping]').on('click', function() {
        if ($('[data-shipping]:checked').length > 0) {
            $('#shipping-form').slideDown();
        } else {
            $('#shipping-form').slideUp();
        }
    });
    /*=====  End of shipping form toggle  ======*/







    /* Trigger Sidemenu */
    function triggerHeader() {
        var menuContainer = $('.header-sidemenu-triggered');
        $('<button class="header-sidemenu-trigger"><i class="fa fa-plus"></i></button>').appendTo(menuContainer)
            .on('click', function() {
                $(this).find('i').toggleClass('fa fa-times fa fa-plus');
                menuContainer.toggleClass('is-visible');
            });
    }
    triggerHeader();




    /* Sidemenu Dropdown */
    function sidemenuDropdown() {
        var $this = $('.header-sidemenu');
        $this.find('nav.menu .cr-dropdown')
            .find('ul').slideUp();
        $this.find('nav.menu li.cr-dropdown > a, nav.menu li.cr-sub-dropdown > a').on('click', function(e) {
            e.preventDefault();
            $(this).next().slideToggle();
        });
    }
    sidemenuDropdown();

    $('.slider-for-var').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        asNavFor: '.slider-nav-var'
    });

    $('.slider-nav-var').slick({
        slidesToShow: 3,
        slidesToScroll: 1,
        asNavFor: '.slider-for-var',
        dots: false,
        centerMode: false,
        focusOnSelect: true,
        arrows: true,
        "vertical": true,
        prevArrow: '<div class="slick-prev"><i class="ion-chevron-left"></i></div>',
        nextArrow: '<div class="slick-next"><i class="ion-chevron-right"></i></div>',
    });



    /*----------------------------
    16. Product Varient
    -----------------------------*/
    $('.grid_color_image li .variant_img').on('click', function() {
        var variantImage = jQuery(this).parent().find('.variant_img a img').attr('src');
        jQuery(this).parents('.furnimal_product-grid').find('.grid-furnimal_product-varient-image a img.primary-img').attr({ src: variantImage });
        return false;
    });

    //$('.variant_img a').addClass('active');

    $('.grid_color_image li .variant_img a').on('click', function() {
        $('.grid_color_image li .variant_img a.active').removeClass('active');
        $(this).addClass('active');
    });


    /*----------------------------
    17. Mouse effect 
    -----------------------------*/
function mousecursor() {
    if ($("body")) {
        const e = document.querySelector(".cursor-inner"),
            t = document.querySelector(".cursor-outer");
        let n, i = 0,
            o = !1;
        window.onmousemove = function (s) {
            o || (t.style.transform = "translate(" + s.clientX + "px, " + s.clientY + "px)"), e.style.transform = "translate(" + s.clientX + "px, " + s.clientY + "px)", n = s.clientY, i = s.clientX
        }, $("body").on("mouseenter", "a, .cursor-pointer", function () {
            e.classList.add("cursor-hover"), t.classList.add("cursor-hover")
        }), $("body").on("mouseleave", "a, .cursor-pointer", function () {
            $(this).is("a") && $(this).closest(".cursor-pointer").length || (e.classList.remove("cursor-hover"), t.classList.remove("cursor-hover"))
        }), e.style.visibility = "visible", t.style.visibility = "visible"
    }
};

$(function () {
    mousecursor();
});


    
    
    
    // Product grid color variant activation code. 
    
    $('.product-color li label').click(function(){
      var variantImage = jQuery(this).parent().find('.hidden a').attr('href');
      jQuery(this).parents('.product-wrapper').find('.popup_cart_image').attr({ src: variantImage }); 
      return false;
    });
    

  });
  
})(jQuery);
